import { render } from "./desulphurization.vue?vue&type=template&id=3f4ce31a&scoped=true"
import script from "./desulphurization.vue?vue&type=script&lang=js"
export * from "./desulphurization.vue?vue&type=script&lang=js"

import "./desulphurization.vue?vue&type=style&index=0&id=3f4ce31a&lang=scss&scoped=scoped"
import "./desulphurization.vue?vue&type=style&index=1&id=3f4ce31a&lang=css"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f4ce31a"]])

export default __exports__